import { render, staticRenderFns } from "./BusinessDetails.vue?vue&type=template&id=123c4ec6"
import script from "./BusinessDetails.vue?vue&type=script&lang=js"
export * from "./BusinessDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports